module.exports = __webpack_public_path__ + "img/Metals-Direct-Inc-logo.31c7390a.png";